import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { WorkProgressMaterialItem } from '../../interfaces/work-progress-material.interface';
import { ManualLabelSelectionIndicatorComponent } from 'app/shared/components/manual-label-selection-indicator';

export interface MaterialActionsCellRendererParams {
  onVerLotes: (data: WorkProgressMaterialItem) => void;
  onExportarMaterial: (data: WorkProgressMaterialItem) => void;
  onExportarLotes: (data: WorkProgressMaterialItem) => void;
}

@Component({
  selector: 'app-material-actions-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatBadgeModule,
    ManualLabelSelectionIndicatorComponent
  ],
  template: `
    <div class="flex items-center justify-center gap-1">
      <app-manual-label-selection-indicator
        [manuallySelected]="manuallySelected"
      ></app-manual-label-selection-indicator>
      <button mat-icon-button
        [matMenuTriggerFor]="actionMenu"
        matTooltip="Acciones">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button mat-menu-item (click)="handleVerLotes()">
          <mat-icon>science</mat-icon>
          Ver lotes
        </button>
        <button mat-menu-item (click)="handleExportarMaterial()">
          <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
          Exportar Material
        </button>
        <button mat-menu-item
          (click)="handleExportarLotes()"
          [disabled]="!hasBatches"
          [matTooltip]="!hasBatches ? 'Este material no tiene lotes' : ''">
          <mat-icon svgIcon="heroicons_outline:list-bullet"
            [matBadge]="batchCount.toString()"
            [matBadgeHidden]="!hasBatches"
            matBadgeSize="small"></mat-icon>
          Exportar Lotes
        </button>
      </mat-menu>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialActionsCellRendererComponent implements CellRenderer<WorkProgressMaterialItem> {
  @Input() params!: CellRendererParams<WorkProgressMaterialItem>;

  get customParams(): MaterialActionsCellRendererParams | undefined {
    return this.params?.colDef?.cellRendererParams as MaterialActionsCellRendererParams;
  }

  get hasBatches(): boolean {
    return this.params?.data?.hasBatches || false;
  }

  get batchCount(): number {
    return this.params?.data?.batchCount || 0;
  }

  /** FS-240: selección manual de lotes/etiquetas en la entrega, de esta línea. */
  get manuallySelected(): boolean {
    return this.params?.data?.deliveryLabelsManuallySelect === true;
  }

  handleVerLotes(): void {
    if (this.customParams?.onVerLotes && this.params?.data) {
      this.customParams.onVerLotes(this.params.data);
    }
  }

  handleExportarMaterial(): void {
    if (this.customParams?.onExportarMaterial && this.params?.data) {
      this.customParams.onExportarMaterial(this.params.data);
    }
  }

  handleExportarLotes(): void {
    if (this.customParams?.onExportarLotes && this.params?.data && this.hasBatches) {
      this.customParams.onExportarLotes(this.params.data);
    }
  }
}
